import React, { Component } from "react";
import _ from "lodash";
import OfflineReportTable from "./OfflineReportTable";

class OfflineCivilSearches extends Component {
  componentDidMount() {}

  render() {
    const crimAcxiomRecs = _.get(
      this.props.data,
      "offline.offlineCriminal[0].crimAcxiom",
      []
    );
    const selectedRecs = _.filter(
      crimAcxiomRecs,
      c => _.get(c, "requestCode[0]", "") > 5000
    );
    return <OfflineReportTable {...this.props} recs={selectedRecs} />;
  }
}

export default OfflineCivilSearches;



// WEBPACK FOOTER //
// ./src/components/myaccount/OfflineCivilSearches.js